import genererCritereRechercheBafCommande
  from '@/services/commande/criteresRecherche/genererCritereRechercheBafCommande';
import * as allTypes from '@/store/mutation-type';
import * as types from '@/store/modules/bafCommande-mutation-type';
import getAll from '@/api/echeancierLigneBaf/index';

function initialState() {
  return {
    bafCommande: [],
    totalBafCommande: 0,
    criteresRecherche: genererCritereRechercheBafCommande(),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_TOTAL_BAF](state, totalBafCommande) {
    state.totalBafCommande = totalBafCommande;
  },
  [types.SET_COMMANDE_BAF](state, bafCommande) {
    state.bafCommande = bafCommande;
  },
};

const actions = {
  async loadCommandeBaf({ commit }, data) {
    const commandesBaf = (await getAll(data));
    commandesBaf.data.result.items.forEach((commande) => {
      commande.selected = false;
    });
    commit(types.SET_COMMANDE_BAF, commandesBaf.data.result.items);
    commit(types.SET_TOTAL_BAF, commandesBaf.data.result.totalCount);
    return {};
  },
};

const getters = {
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  totalBafCommande: state => {
    return state.totalBafCommande;
  },
  bafCommande: state => {
    return state.bafCommande;
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
